/**
 * Utility to notify the generation system when posts are saved
 * This allows the generation progress indicator to auto-dismiss
 */

export const notifyPostSaved = (postId, postGroupId = null, additionalData = {}) => {
    const event = new CustomEvent('postSaved', {
        detail: {
            postId,
            postGroupId,
            timestamp: Date.now(),
            ...additionalData
        }
    });
    
    window.dispatchEvent(event);
};

export const notifyPostGroupSaved = (postGroupId, additionalData = {}) => {
    notifyPostSaved(null, postGroupId, additionalData);
};

export default {
    notifyPostSaved,
    notifyPostGroupSaved
};
